import styled from "styled-components";

const ConversationLayout = styled.div`
  display: flex;
  margin: 1%;
  padding: 1%;
  background-color: #4e4643;
  border-radius: 20px;
  box-shadow: 0 5px 5px #000000;
`;

export default ConversationLayout;
